import React from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'


const folderItems = [
  { name: 'Projetos', icon: 'folder', color: 'primary', size: '3.2 MB', files: 12 },
  { name: 'Marketing', icon: 'folder', color: 'success', size: '1.8 MB', files: 8 },
  { name: 'Documentos', icon: 'folder', color: 'warning', size: '5.4 MB', files: 23 },
]

const FileManagerFoldersPage: React.FC = () => {
  return (
    <>
      <PageTitle>Gerenciador de Arquivos - Pastas</PageTitle>
      <KTCard>
        <KTCardBody>
          <div className='row g-6'>
            {folderItems.map((item, index) => (
              <div className='col-xl-4' key={index}>
                <div className='d-flex flex-column p-5 border rounded shadow-sm h-100'>
                  <div className='symbol symbol-50px mb-3'>
                    <span className={`symbol-label bg-light-${item.color}`}>
                      <i className={`ki-duotone ki-${item.icon} text-${item.color} fs-2`}></i>
                    </span>
                  </div>
                  <div className='fs-4 fw-bold'>{item.name}</div>
                  <div className='text-muted'>
                    {item.files} arquivos – {item.size}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export default FileManagerFoldersPage
